import { useRef, useEffect } from 'react';
import { Icon } from '@iconify/react';
import googleFill from '@iconify/icons-eva/google-fill';
import twitterFill from '@iconify/icons-eva/twitter-fill';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import instagramFilled from '@iconify/icons-ant-design/instagram-filled';

import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, IconButton, Stack } from '@mui/material';
// routes
import { PATH_PAGE } from '../../routes/paths';
import { useDispatch, useSelector } from '../../redux/store';
import { getAlamatList } from '../../redux/slices/lelang';
//
import Logo from '../../components/Logo';

// ----------------------------------------------------------------------

const SOCIALS = [
  { name: 'FaceBook', icon: facebookFill, href: 'https://www.facebook.com/BankMuamalatIndonesia/' },
  { name: 'Instagram', icon: instagramFilled, href: 'https://www.instagram.com/bank.muamalat/' },
  { name: 'Twitter', icon: twitterFill, href: 'https://twitter.com/BankMuamalat' }
];

const LINKS = [
  {
    headline: 'Minimal',
    children: [
      { name: 'About us', href: PATH_PAGE.about },
      { name: 'Contact us', href: PATH_PAGE.contact },
      { name: 'FAQs', href: PATH_PAGE.faqs }
    ]
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Condition', href: '#' },
      { name: 'Privacy Policy', href: '#' }
    ]
  },
  {
    headline: 'Contact',
    children: [
      { name: 'support@minimals.cc', href: '#' },
      { name: 'Los Angeles, 359  Hidden Valley Road', href: '#' }
    ]
  }
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  const dispatch = useDispatch();
  const { alamat } = useSelector((state) => state.lelang);

  useEffect(() => {
    dispatch(getAlamatList());
  }, [dispatch]);

  return (
    <RootStyle>
      <Container maxWidth="false" sx={{ pt: 3 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'center' }}
          sx={{ textAlign: { xs: 'center', md: 'center' } }}
          md={12}
        >
          <Grid item xs={5} md={5}>
            <Stack>
              <Typography
                component="p"
                variant="body2"
                sx={{
                  fontSize: 13,
                  textAlign: { xs: 'center', md: 'left' }
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${alamat.contents}`
                  }}
                />
              </Typography>
            </Stack>
            <Stack spacing={1.5} direction="row" justifyContent={{ xs: 'center', md: 'flex-start' }}>
              {SOCIALS.map((social) => (
                <IconButton to={social.href} key={social.name} color="primary" sx={{ p: 1 }}>
                  <Icon icon={social.icon} width={16} height={16} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={2} md={3}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {' '}
            </Stack>
          </Grid>
          <Grid item xs={3} md={3}>
            <Stack direction="row" justifyContent={{ xs: 'left', md: 'right' }}>
              <img src="/static/\home/ojk.png" alt="ojk" />
            </Stack>

            <Stack>
              <Typography
                component="p"
                variant="body2"
                sx={{
                  pb: 2,
                  fontSize: 13,
                  textAlign: { xs: 'left', md: 'right' }
                }}
              >
                © 2021. PT Bank Muamalat Tbk. All rights reserved
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
}
